import { connect } from "react-redux";
import EditTitleForm from "./EditTitleForm"
import { submitFormError, clearFormErrors, checkNameAvailability} from "../../../../../redux/actions/wi_actions"

const mapStateToProps = (state) => {
    return ({
        errors: state.errors.wi
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        checkNameAvailability: (title) => dispatch(checkNameAvailability(title)),
        submitFormError: (error) => dispatch(submitFormError(error)),
        clearFormErrors: () => dispatch(clearFormErrors()),
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTitleForm);